import { jsxs, jsx } from "react/jsx-runtime";
import { Columns, Column, Text, Secondary, Box } from "braid-design-system";
import { breakWord } from "./JobInformationItem.css.mjs";
const JobInformationItem = ({
  label,
  value
}) => {
  const valueContent = typeof value === "string" ? /* @__PURE__ */ jsx(Text, { children: value }) : value;
  return /* @__PURE__ */ jsxs(Columns, { space: "small", collapseBelow: "tablet", children: [
    /* @__PURE__ */ jsx(Column, { width: "1/3", children: /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsx(Secondary, { children: label }) }) }),
    /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsx(Box, { className: breakWord, children: valueContent }) })
  ] });
};
export {
  JobInformationItem
};
